import { useStartWeb3Tunnel } from "./ApiCerts/axiosStartTunnel";
import { MASTERCHAIN_CONFIRM_TRANSACTION } from "./axios";
import {config} from "../config";
import useSetUrlForAxiosBlockChainReq
  from "../utils/CustomHooks/useSetUrlForAxiosBlockChainReq/useSetUrlForAxiosBlockChainReq";

/**
 * Request handler hook
 * @param {axios : import("axios").AxiosInstance} axios
 * @returns {(description : string | undefined) => (data : Promise) => Promise}
 */


export function useWeb3Handler(axios) {
  const createWeb3 = useStartWeb3Tunnel();

  return (description) =>
    ({ data: { requests: data } }) =>
      createWeb3().then((web3) =>
        signWithBlockchain(data, { web3, axios }, description)
      );
}

/**
 * Sign request that came from the api with blockchain + send confirmation to api
 * @param {Array} data Request array from api
 * @param {{
 *  web3 : import("web3").Web3<RegisteredSubscription>,
 *  axios : import("axios").AxiosInstance
 * }} instances Instances of connection objects
 * @param {string | undefined} description
 * @returns {Promise<import("axios").AxiosResponse>}
 */

function signWithBlockchain(data, { web3, axios }, description) {
  // Make requests to blockchain
  return Promise.all(
    data.map((apiRes) => {
      return web3.eth.sendTransaction({
        // from: "0x24e965d799d60bf9ba517410ddadd926bdd2deae",
        from: config.WEB_3_KEY_FROM,
        to: apiRes.params[0].to,
        data: apiRes.params[0].data,
      });
    })
  ).then((responces) => {
    // If all requests are successful than pass params for confirmation request
    if (responces.every((responce) => Number(responce.status) === 1))
      return axios.post(MASTERCHAIN_CONFIRM_TRANSACTION, undefined, {
        baseURL: config.BASE_URL_API !== config.BASE_URL ? config.BASE_URL_API : config.BASE_URL_PROXY,
        // baseURL: config.BASE_URL_PROXY,
        params: {
          id: data[0].docId,
          doc_type: data[0].docType,
          description,
        },
      });
    else return Promise.reject(responces);
  });
}
